import request from 'utils/request'
import { MCAXS561QueryRequest } from 'types/MCAXS561/MCAXS561QueryRequest'

export const getMCAXS561InitRequest = (data: MCAXS561QueryRequest) =>
  request({
    url: '/MCAXS561/init',
    method: 'post',
    data: data,
  })
